export default __webpack_public_path__ + "static/media/backgroudHome.151c9728.png";